module.exports = __webpack_public_path__ + "images/data7.png";